import { render, staticRenderFns } from "./IELTScoreComponent.vue?vue&type=template&id=e684bbee&scoped=true&"
import script from "./IELTScoreComponent.vue?vue&type=script&lang=js&"
export * from "./IELTScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./IELTScoreComponent.vue?vue&type=style&index=0&id=e684bbee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e684bbee",
  null
  
)

export default component.exports